import type { Comment } from '@services/dto/comment';

export type CommentChannel = {
  channel: string;
  sourceChannel?: string;
  name?: string;
  userId?: string;
  userType?: string;
  scope?: string;
  role?: string;
  newCount: number;
};

export type CommentChannels = {
  accountId: string;
  projectId?: string;
  groups: CommentChannel[];
  direct: CommentChannel[];
};

export type CommentEx = Comment & {
  newCount?: number;
};

export type CommentPanelView = 'closed' | 'open' | 'full';
export type CommentPanelState = {
  view?: CommentPanelView;
  title?: string;
  accountId?: string;
  projectId?: string;
};

export type CommentsState = {
  ready: boolean;
  channels?: CommentChannels;
  currentChannel?: CommentChannel;
  comments: { [channel: string]: CommentEx[] };
  panel: CommentPanelState;
};
